<template>
  <div>
    <a-input-search placeholder="input search text" enter-button @search="onSearch" />
    <br /><br />
    <a-table :columns="columns" :data-source="data">
      <a slot="action" slot-scope="text,record"  @click="getactive(record.appkey)">操作</a>
    </a-table>  
  </div>
</template>
<script>
const columns = [
        {
          title: '千寻账号',
          dataIndex: 'appkey',
          scopedSlots: { customRender: 'name' },
        },{
          title: '状态',
          dataIndex: 'state',
          scopedSlots: { customRender: 'active' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ];



export default {
  data() {
    let param = {
        page:1,
        pagenum:10
    }
    let terminallist;
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/qxaccount/list',
      data: obj
    }).then((response) =>{          //这里使用了ES6的语法
       
       
       for(var i=0;i<response.data.length;i++)
       {
        console.log(response.data[i]['state'])
          switch(response.data[i]['state'])
          {
            case 1:
              response.data[i]['state'] = '闲置'
              break;
              case 2:
                response.data[i]['state'] = '启用'
              break;
              case 3:
                response.data[i]['state'] = '停用'
              break;
          }
       }
       this.data = response.data
       this.Showpage = true
       console.log(response)       //请求成功返回的数据
    }).catch((error) =>{
         console.log(error)       //请求失败返回的数据       
    })
    return {
      Showpage:false,
      data:terminallist,
      columns
    };
  },
  methods:{
    handleEdit(key){
      this.$store.state.appkey = key;
      this.$router.push('/home/qxaccountdetail');
    },
    getactive(key){
      this.$store.state.appkey = key;
      this.$router.push('/home/qxaccountdetail');
    },
    
    onSearch(value){
      this.$store.state.appkey = value;
      this.$router.push('/home/qxaccountdetail');
    }
    
  },
};
</script>



// WEBPACK FOOTER //
// src/components/QxaccountList.vue